<template>
    <div>
        <CommunicationChannelModal
            ref="communicationChannel"
            :communication-channel="communicationChannel"
            :expected-domain="expectedDomain"
            @save="onChannelSave"
        />
        <b-modal
            ref="contact-modal"
            :ok-title="okTitle"
            ok-variant="dark"
            ok-only
            @ok="save"
            centered
            size="lg"
            :title="$t('Component(ContactModal):label')"
        >
            <b-form class="pb-1">
                <b-form-group
                    :label="$t('Component(Label):contact-name')"
                    label-for="name"
                >
                    <b-form-input
                        id="name"
                        :placeholder="$t('Component(Placeholder):contact-name')"
                        v-model="name"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Component(Label):contact-position')"
                    label-for="name"
                >
                    <b-form-input
                        id="name"
                        :placeholder="$t('Component(Placeholder):contact-position')"
                        v-model="position"
                    />
                </b-form-group>

                <b-form-group
                    :label="$t('Component(Label):contact-description')"
                    label-for="name"
                >
                    <b-form-input
                        id="name"
                        :placeholder="$t('Component(Placeholder):contact-description')"
                        v-model="description"
                    />
                </b-form-group>
            </b-form>

            <HamletTable
                :columns="columns"
                :fetch="getCommunicationChannels"
                :page-options="[5]"
                :default-per-page="5"
                @onRowClick="onCommunicationChannelClick"
                @created="onCommunicationChannelsTableCreated"
            >
                <template #header-label>
                    {{ $t('Component(ContactModal):communication-types') }}
                </template>

                <template #header-controls>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mt-0 btn-icon"
                        @click="addCommunicationChannel"
                    >
                        <feather-icon icon="PlusIcon" />
                    </b-button>
                </template>

                <template #cell-communicationType="data">
                    {{ $t('Enum(CommunicationType):' + data.item.type) }}
                </template>

                <template #cell-communicationChannel="data">
                    {{ data.item.channel }}
                </template>

                <template #cell-actions="data">
                    <div class="text-right">
                        <Button
                            variant="primary"
                            :class="{'btn-icon': true, 'mr-1': removeActionVisible}"
                        >
                            <feather-icon icon="EditIcon" />
                        </Button>
                        <b-button
                            v-if="removeActionVisible"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="danger"
                            class="btn-icon"
                            @click.prevent.stop="removeCommunicationChannel(data.item)"
                        >
                            <feather-icon icon="Trash2Icon" />
                        </b-button>
                    </div>
                </template>
            </HamletTable>
        </b-modal>
    </div>
</template>

<script>
import {BFormGroup, BButton, BFormInput, BModal, BForm,} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import HamletTable from "@core/components/common/HamletTable";
import CommunicationChannelModal from "@core/components/supply-chain/CommunicationChannelModal";
import {CommunicationType} from "@/libs/supply-chain";
import Button from "@core/components/common/Button.vue";

export default {
    directives: {Ripple},
    components: {
        Button,
        BModal, BForm, BFormInput, BFormGroup, HamletTable, BButton,
        CommunicationChannelModal
    },
    props: {
        contact: {
            type: Object,
            default() {
                return {};
            }
        },
        expectedDomain: {
            default: null
        },
        actionsVisible: {
            default: true
        },
        removeActionVisible: {
            default: true
        }
    },
    data() {
        const columns = [
            {
                key: 'communicationType',
                label: this.$t('Component(Grid):column-communication-type')
            },
            {
                key: 'communicationChannel',
                label: this.$t('Component(Grid):column-communication-channel')
            },
        ];

        if (this.actionsVisible) {
            columns.push(
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions')
                }
            )
        }

        return {
            columns: columns,

            id: null,
            name: null,
            position: null,
            description: null,
            communicationChannel: {
                type: null,
                channel: null
            },
            communicationChannels: [],
            communicationChannelFetch: null,
            communicationChannelId: 1,
        };
    },
    methods: {
        populate(id, contact) {
            this.id = id;
            this.name = contact.name;
            this.position = contact.position;
            this.description = contact.description;
            this.communicationChannels = contact.communicationChannels;
        },
        addCommunicationChannel() {
            this.communicationChannel = null;
            this.$refs.communicationChannel.show();
        },
        onCommunicationChannelClick(communicationChannel) {
            this.communicationChannel = communicationChannel;
            this.$refs.communicationChannel.populate(communicationChannel.type, communicationChannel.channel);
            this.$refs.communicationChannel.show();
        },
        onCommunicationChannelsTableCreated(config, fetchHandler) {
            this.communicationChannelFetch = fetchHandler;
        },
        onChannelSave(channel) {
            if (this.communicationChannel) {
                this.communicationChannel.type = channel.type;
                this.communicationChannel.channel = channel.channel;
            } else {
                this.communicationChannels.push({
                    ...channel,
                    _id: this.communicationChannelId++
                });
                this.communicationChannelFetch(
                    this.communicationChannels.length,
                    this.communicationChannels
                );
            }
        },
        getCommunicationChannels(config, cb) {
            const start = (config.page - 1) * config.perPage;
            cb(
                this.communicationChannels.length,
                this.communicationChannels.slice(start, start + config.perPage)
            );
        },
        save() {
            this.$emit('save', this.id, {
                name: this.name,
                position: this.position,
                description: this.description,
                communicationChannels: this.communicationChannels
            });
        },
        removeCommunicationChannel(communicationChannel) {
            let index = this.communicationChannels.findIndex(
                communicationChannel.id
                    ? c => c.id === communicationChannel.id
                    : c => c._id === communicationChannel._id
            );
            if (index >= 0) {
                this.communicationChannels.splice(index, 1);
            }

            this.communicationChannelFetch(
                this.communicationChannels.length,
                this.communicationChannels
            );
        },
        blank() {
            this.populate(null, {
                name: null,
                position: null,
                description: null,
                communicationChannels: []
            });
        },
        show() {
            this.$refs['contact-modal'].show();
        },
        hide() {
            this.$refs['contact-modal'].hide();
        },
    },
    computed: {
        okTitle() {
            return this.$t('Component(Button):back');
        }
    }
}
</script>
